<template>
  <div class="home">
    <patent-search />
    <div class="container">
      <div class="l">
        <div class="monthly card">
          <div class="top">各校转化专利
            <!-- <div class="more">更多</div> -->
          </div>
          <ul>
            <li v-for="(item, index) in monthly" :key="item.id">
              <div class="from">{{ item.collegeApplicant }}</div>
              <div class="title" @click="$router.push({ name: 'patentDetail', query: { id: item.id } })">{{
              item.inventionName }}</div>

            </li>
          </ul>
        </div>
        <div class="recommend card">
          <div class="top">各校推荐专利</div>
          <ul>
            <li v-for="(item, index) in monthly" :key="item.id">
              <div class="from">{{ item.collegeApplicant }}</div>
              <div class="title" @click="$router.push({ name: 'patentDetail', query: { id: item.id } })">{{
              item.inventionName }}</div>

            </li>
          </ul>
        </div>
      </div>
      <div class="r">
        <!-- <div class="chara card">
          <div class="top-r">特色功能</div>
          <div class="chara-c">
            <div class="chara-i" @click="$router.push('/patent')">
              <div class="icon1"></div>
              <div class="text">高级检索</div>
            </div>
            <div class="chara-i" @click="$router.push('/stock')">
              <div class="icon2"></div>
              <div class="text">知产学堂</div>
            </div>
            <div class="chara-i" @click="$router.push({ name: 'chartsDetail' })">
              <div class="icon3"></div>
              <div class="text">统计分析</div>
            </div>
            <div class="chara-i">
              <div class="icon4"></div>
              <div class="text">申请人</div>
            </div>
          </div>
        </div> -->

        <div class="chara card">
          <div class="top-r">服务清单</div>
          <div class="chara-c">
            <div class="chara-i" @click="$router.push({ name: 'servicelist', query: { current: 0 } })">
              <div class="icon5"></div>
              <div class="text">专利申请前服务清单</div>

            </div>
            <div class="chara-i" @click="$router.push({ name: 'servicelist', query: { current: 1 } })">
              <div class="icon6"></div>
              <div class="text">专利转化服务清单</div>
            </div>
            <!-- <div class="chara-i" @click="$router.push({ name: 'servicelist', query: { current: 2 } })">
              <div class="icon7"></div>
              <div class="text">专利代理服务清单</div>
            </div> -->
            <div class="chara-i" @click="$router.push({ name: 'servicelist', query: { current: 3 } })">
              <div class="icon8"></div>
              <div class="text">其他清单</div>
            </div>
          </div>
        </div>

        <div class="chara card">
          <div class="top-r">用户入口</div>
          <div class="chara-c">
            <div class="chara-i" @click="$router.push({ name: 'user_entrance', query: { current: 0 } })">
              <div class="icon9"></div>
              <div class="text">技术需求方</div>
            </div>
            <div class="chara-i" @click="$router.push({ name: 'user_entrance', query: { current: 1 } })">
              <div class="icon10"></div>
              <div class="text">创新主体方</div>
            </div>
            <div class="chara-i" @click="$router.push({ name: 'user_entrance', query: { current: 2 } })">
              <div class="icon11"></div>
              <div class="text">分析管理方</div>
            </div>
          </div>
        </div>

        <div class="news card">
          <div class="top-r">新闻动态</div>
          <ul>
            <li v-for="(item, index) in newsList" :key="item.id"
              @click="$router.push({ name: 'newsDetail', query: { id: item.id } })">
              <div class="title">{{ item.title }}</div>
              <div class="from">{{ item.createTime }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="f4">
      <div class="ctn">
        <div class="item">
          <div class="title-ctn">
            <div class="title">获奖专利</div>
            <div class="more">更多</div>
          </div>
          <!-- applicationDate -->
          <div class="content">
            <ul>
              <li v-for="(item, index) in prize" :key="item.applicationNo"
                @click="$router.push({ name: 'patentDetail', query: { id: item.id } })">
                <div class="title">{{ item.inventionName }}</div>
                <div class="date">{{ item.applicationDate.split(' ')[0] }}</div>
              </li>
              <!-- <li>
                <div class="title">实用新型专利 中国石油大学实用新型专利 中国石油大学实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
              <li>
                <div class="title">实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
              <li>
                <div class="title">实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
              <li>
                <div class="title">实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li> -->
            </ul>
            <!-- <ul>
              <li v-for="item in prize" :key="item.id">
                {{ item.inventionName }}
              </li>
            </ul> -->
          </div>
        </div>
        <div class="item">
          <div class="title-ctn">
            <div class="title">海外同族</div>
            <div class="more">更多</div>
          </div>
          <div class="content">
            <ul>
              <li v-for="(item, index) in overseas" :key="item.applicationNo"
                @click="$router.push({ name: 'patentDetail', query: { id: item.id } })">
                <div class="title">{{ item.inventionName }}</div>
                <div class="date">{{ item.applicationDate.split(' ')[0] }}</div>
              </li>
              <!-- <li>
                <div class="title">实用新型专利 中国石油大学实用新型专利 中国石油大学实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
              <li>
                <div class="title">实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
              <li>
                <div class="title">实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
              <li>
                <div class="title">实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li> -->
            </ul>
          </div>
        </div>
        <!-- <div class="item">
          <div class="title-ctn">
            <div class="title">开放许可</div>
            <div class="more">更多</div>
          </div>
          <div class="content">
            <ul>
              <li>
                <div class="title">实用新型专利 中国石油大学实用新型专利 中国石油大学实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
              <li>
                <div class="title">实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
              <li>
                <div class="title">实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
              <li>
                <div class="title">实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
            </ul>
          </div>
        </div> -->
        <!-- <div class="item">
          <div class="title-ctn">
            <div class="title">优先审查</div>
            <div class="more">更多</div>
          </div>
          <div class="content">
            <ul>
              <li>
                <div class="title">实用新型专利 中国石油大学实用新型专利 中国石油大学实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
              <li>
                <div class="title">实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
              <li>
                <div class="title">实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
              <li>
                <div class="title">实用新型专利 中国石油大学</div>
                <div class="date">2021-08-18</div>
              </li>
            </ul>
          </div>
        </div> -->
      </div>

      <div class="outline1 card">
        <div class="top">友情链接</div>
        <div class="ctn">

          <div class="ol-item" @click="outlineClick('https://www.cnipa.gov.cn/')">
            <div><img :src="require('@/assets/img/outline-icon.png')" /> 国家知识产权局</div>
          </div>
          <div class="ol-item" @click="outlineClick('https://www.patent.com.cn/')">
            <div><img :src="require('@/assets/img/outline-icon.png')" /> 中国专利信息网</div>
          </div>
          <div class="ol-item" @click="outlineClick('http://amr.shandong.gov.cn/')">
            <div><img :src="require('@/assets/img/outline-icon.png')" /> 山东省市场监督管理局</div>
            <div>（知识产权局）</div>
          </div>
          <div class="ol-item" @click="outlineClick('http://petrochemical.areaip.cn/')">
            <div><img :src="require('@/assets/img/outline-icon.png')" /> 石油和化工行业专利服务平台</div>
          </div>


          <!-- <div class="ol-item"><img :src="require('@/assets/img/outline-icon.png')" />中国专利信息网</div>
          <div class="ol-item"><img :src="require('@/assets/img/outline-icon.png')" />
            山东省市场监督管理局
            <p>（知识产权局）</p>
          </div>
          <div class="ol-item"><img :src="require('@/assets/img/outline-icon.png')" />石油和化工行业专利服务平台</div> -->
        </div>
      </div>
    </div>


  </div>
</template>

<script>
// @ is an alias to /src
import patentSearch from '@/components/patent-search.vue'
import { getPatentList, getMonthlyPatentList } from '@/api/patent'
import { getNewsList } from '@/api/news'

export default {
  name: 'HomeView',
  data() {
    return {
      monthly: [], // 各校转化专利
      recommend: [], // 各校推荐专利
      prize: [], // 获奖专利
      overseas: [], // 海外同族
      newsList: [],

      patent1: [ // 各校转化专利
        "CN113006742B",
        "CN112031752B",
        "CN112036097B",
        "CN111810119B",
        "CN110685651B",
        "CN110334431B",
        "CN208749314U",
        "CN108547595B",
        "CN107143323B",
        "CN106194114B",
        "CN106194115B",
        "CN105822289B",
        "CN104389586B",
        "CN102022084B",
      ],
      patent2: [ // 获奖专利
        "CN110056329B",
        "CN109666468B",
        "CN107542429B",
        "CN107545113B",
        "CN106285579B",
        "CN106430167B",
        "CN105735961B",
        "CN103773408B",
        "CN103589414B",
        "CN103603656B",
        "CN103075117B",
        "CN102996106B",
        "CN102943620B",
        "CN102704857B",
        "CN102331588B",
        "CN102051161B",
        "CN102141637B",
        "CN100494626C",
      ],
      patent3: [ // 海外同族
        "US11879817B2",
        "LU504389B1",
        "US11840928B1",
        "US11773714B1",
        "US11732551B1",
        "NL2034676B1",
        "US11898421B2",
        "US20240037301A1",
        "US11865500B2",
        "LU503587B1",
        "US11822046B2",
        "LU503545B1",
        "US11787893B1",
        "JP7297353B1",
        "US20230417113A1",
        "US11828149B1",
        "BE1030200B1",
        "JP7355428B2",
        "US11668148B1",
        "NL2033450B1",
      ]
    }
  },
  components: {
    patentSearch
  },
  async mounted() {
    const patentList = await getPatentList({ pageSize: 6, page: 1 });


    // let formData = new FormData();
    // formData.append("tpatent.public_no_^VIN", this.patent1.join(','));
    // formData.append("noPage", "true");
    // const patent1List = await getMonthlyPatentList(formData);

    // this.monthly = patent1List.rows.slice(0, 6);
    this.monthly = await this.getPatentListFromPubNumber(this.patent1);
    // console.log('monthly', this.monthly);
    this.prize = await this.getPatentListFromPubNumber(this.patent2);
    this.overseas = await this.getPatentListFromPubNumber(this.patent3);

    const newsList = await getNewsList();
    this.newsList = newsList.rows;
  },
  methods: {
    outlineClick(url) {
      window.open(url)
    },
    async getPatentListFromPubNumber(pubNumList) {
      let formData = new FormData();
      formData.append("tpatent.public_no_^VIN", pubNumList.join(','));
      formData.append("noPage", "true");
      const data = await getMonthlyPatentList(formData);
      return data.rows.length <= 6 ? data.rows : data.rows.slice(0, 6);
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  background-color: #fff;
  // padding-bottom: 30px;
}

.container {
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: center;
  margin-top: 30px;

  .card {
    background-color: #F5F5F5;
    box-shadow: 0px 2px 6px 0px #EAEEF4;
    border-radius: 10px;
    padding: 20px 5px;
    box-sizing: border-box;

    .top {
      font-size: 26px;
      font-weight: bold;
      position: relative;
      left: 30px;
      color: #003A80;
      display: flex;
      justify-content: space-between;

      &::before {
        content: "";
        display: inline-block;
        width: 30px;
        height: 25px;
        background-image: url("@/assets/img/index-icon1.png");
        background-repeat: no-repeat;
        position: absolute;
        top: 50%;
        left: -30px;
        transform: translateY(-50%);
      }

      &::after {
        content: "更多";
        display: block;
        position: absolute;
        right: 40px;
        font-size: 14px;
        color: #333333;
        top: 50%;
        transform: translateY(-50%);
        font-weight: 400;
      }
    }

    .top-r {
      width: 200px;
      height: 35px;
      background-image: url("@/assets/img/index-icon2.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;

      font-size: 22px;
      font-weight: bold;
      color: #FFFFFF;
      padding: 0px 50px;

      position: absolute;
      top: -14px;
    }

    ul {
      margin-top: 10px;
    }

    li {
      display: flex;
      justify-content: space-between;
      // height: 40px;
      // line-height: 40px;
      cursor: pointer;
      margin-bottom: 20px;

      .title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }

    .change {
      margin-top: 10px;
      text-align: center;
    }
  }

  .l {
    width: 385px;
    flex: 0 0 385px;

    .monthly {
      height: 320px;

      .title {
        width: 240px;
      }

      .from {
        width: 170px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        background: #E4F0FF;
        border-radius: 18px;
        color: #003A80;
        padding: 2px 0 2px 10px;
      }

    }

    .recommend {
      height: 320px;
      margin-top: 30px;

      .title {
        width: 240px;
      }

      .from {
        width: 170px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        background: #E4F0FF;
        border-radius: 18px;
        color: #003A80;
        padding: 2px 0 2px 10px;
      }
    }
  }

  .r {
    width: 790px;
    margin-left: 25px;

    .chara {
      margin-bottom: 30px;
      padding: 0;
      position: relative;

      .chara-c {
        display: flex;
        justify-content: space-around;
        padding-top: 20px;

        .chara-i {
          width: 160px;
          height: 130px;
          // background-color: $ctextbg;
          display: flex;
          flex-direction: column;
          justify-content: center;
          // border-radius: 10px;
          cursor: pointer;
          transition: all 0.5s;
          // box-shadow: 5px 5px 10px #eee;

          &:hover {
            transform: scale(1.1);
          }

          .icon1,
          .icon2,
          .icon3,
          .icon4,
          .icon5,
          .icon6,
          .icon7,
          .icon8,
          .icon9,
          .icon10,
          .icon11 {
            height: 45px;
            width: 45px;
            background-repeat: no-repeat;
            background-position: 50% 50%;
            margin: auto;

            // background-size: cover;
            background-size: 90%, 90%;
          }

          .icon1 {
            background-image: url("@/assets/img/1.png");
          }

          .icon2 {
            background-image: url("@/assets/img/2.png");
          }

          .icon3 {
            background-image: url("@/assets/img/3.png");
          }

          .icon4 {
            background-image: url("@/assets/img/4.png");
          }

          .icon5 {
            background-image: url("@/assets/img/5.png");
          }

          .icon6 {
            background-image: url("@/assets/img/6.png");
          }

          .icon7 {
            background-image: url("@/assets/img/7.png");
          }

          .icon8 {
            background-image: url("@/assets/img/8.png");
          }

          .icon9 {
            background-image: url("@/assets/img/9.png");
          }

          .icon10 {
            background-image: url("@/assets/img/10.png");
          }

          .icon11 {
            background-image: url("@/assets/img/11.png");
          }

          .text {
            margin: auto;
            text-align: center;
          }
        }

      }
    }

    .news {
      // height: 510px;
      margin-top: 30px;
      position: relative;
      padding-bottom: 0;
    }
  }
}

.f4 {
  width: 100%;

  margin-top: 30px;
  background-image: url('@/assets/img/bgstart2.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: -200px;
  padding: 50px 0;

  .ctn {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: auto;
  }

  .item {
    width: 560px;
    height: 290px;
    background-color: #fff;
    margin-bottom: 50px;
    border-radius: 10px;
    padding: 10px;
    position: relative;

    &:nth-child(1) {
      .title::before {
        background-image: url('@/assets/img/index-icon-hjzl.png');
      }
    }

    &:nth-child(2) {
      .title::before {
        background-image: url('@/assets/img/index-icon-hwzl.png');
      }
    }

    &:nth-child(3) {
      .title::before {
        background-image: url('@/assets/img/index-icon-kfxk.png');
      }
    }

    &:nth-child(4) {
      .title::before {
        background-image: url('@/assets/img/index-icon-yxsc.png');
      }
    }

    .title-ctn {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        font-size: 20px;
        font-weight: bold;
        color: #003A80;
        position: relative;
        left: 50px;
        height: 40px;

      }

      .title::before {
        content: '';
        display: block;
        width: 40px;
        height: 40px;
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        left: -50px;
      }
    }

    .content {
      li {
        width: 530px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        list-style: disc;
        cursor: pointer;

        .title {
          width: 450px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
}

.outline1 {
  width: 1200px;
  margin: 30px auto 0;

  &.card {
    box-sizing: border-box;

    .top {
      font-size: $size-h1;
      position: relative;

      &::after {
        content: "";
        display: block;
        width: 100px;
        height: 3px;
        background-color: #c61c1c;
        position: absolute;
      }
    }

    .ctn {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;


      .ol-item {
        width: 260px;
        height: 70px;
        background-color: #fff;
        font-size: 16px;
        color: #333333;
        letter-spacing: 1px;
        text-align: center;
        // line-height: 70px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;

        img {
          height: 20px;
          width: 20px;
        }

        div {}
      }

    }
  }
}
</style>
